import React from "react";
import logoZandona from "../../../../assets/images/logo-zandona-transparent.png";
import logoElemental from "../../../../assets/images/logo-elemental.png";
import {
  Footer,
  InfoContainer,
  VerticalLine,
  LogoZandona,
  TextZandona,
  LocationImg,
  AddressText,
  LogoElemental,
  ElementalWrapper,
} from "./TotemFooterStyles";

const TotemFooter: React.FC = () => {
  return (
    <Footer>
      <InfoContainer>
        <LogoZandona src={logoZandona} alt="Logo da Zandoná" />
        <TextZandona>
          {/* <p>Blablablablabla Blablablablabla</p>
          <p>Blablablablabla Blablablablabla</p>
          <p>Blablablablabla Blablablablabla</p>
          <p>Blablablablabla Blablablablabla</p> */}
        </TextZandona>
      </InfoContainer>
      <VerticalLine />
      <InfoContainer>
        <LocationImg />
        <TextZandona>
          <AddressText>Endereço Atual</AddressText>
          <ElementalWrapper>
            <LogoElemental src={logoElemental} />
            <p>
              powered
              <br />
              by
            </p>
          </ElementalWrapper>
        </TextZandona>
      </InfoContainer>
    </Footer>
  );
};

export default TotemFooter;
